import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form8.css";

const Form8 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    contactTime: "",
    whatsapp: "",
    callPreference: "",
    pastExperience: "",
    health: "",
    dislikes: "",
    additional: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleReset = () => {
    setFormData({
      contactTime: "",
      whatsapp: "",
      callPreference: "",
      pastExperience: "",
      health: "",
      dislikes: "",
      additional: "",
    });
    setErrors({});
  };

  const validate = () => {
    let err = {};

    if (!formData.contactTime.trim()) {
      err.contactTime = "Please enter preferred contact time";
    }

    if (!formData.whatsapp) {
      err.whatsapp = "Please select Yes or No";
    }

    if (!formData.callPreference) {
      err.callPreference = "Please select Call or Message";
    }

    if (!formData.pastExperience.trim()) {
      err.pastExperience = "Please share past travel experience";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      alert("Form Submitted Successfully!");
    }
  };

  return (
    <div className="support-main">
      <div className="left-section">
        <h1>Support & Communication Preferences</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="support-form">
          <label>Preferred Contact Time</label>
          <input
            type="text"
            name="contactTime"
            placeholder="Enter your preferred time"
            value={formData.contactTime}
            onChange={handleChange}
          />
          {errors.contactTime && <p className="error">{errors.contactTime}</p>}

          <label>WhatsApp Updates Required?</label>
          <div className="button-group">
            {["Yes", "No"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${
                  formData.whatsapp === item ? "active" : ""
                }`}
                onClick={() => handleSelect("whatsapp", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.whatsapp && <p className="error">{errors.whatsapp}</p>}

          <label>Call / Message Preference</label>
          <div className="button-group">
            {["Call", "Message"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${
                  formData.callPreference === item ? "active" : ""
                }`}
                onClick={() => handleSelect("callPreference", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.callPreference && (
            <p className="error">{errors.callPreference}</p>
          )}

          <label>Past Travel Experience</label>
          <input
            type="text"
            name="pastExperience"
            placeholder="Share your past travel experiences"
            value={formData.pastExperience}
            onChange={handleChange}
          />
          {errors.pastExperience && (
            <p className="error">{errors.pastExperience}</p>
          )}

          <label>Health Concerns (optional)</label>
          <input
            type="text"
            name="health"
            placeholder="Mention any health concerns"
            value={formData.health}
            onChange={handleChange}
          />

          <label>Any Dislikes / Restrictions</label>
          <input
            type="text"
            name="dislikes"
            placeholder="Share any dislikes or restrictions"
            value={formData.dislikes}
            onChange={handleChange}
          />

          <label>Anything Else You Want to Add</label>
          <input
            type="text"
            name="additional"
            placeholder="Additional comments or requests"
            value={formData.additional}
            onChange={handleChange}
          />

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="button" className="reset-btn" onClick={handleReset}>
              Reset
            </button>

            <button type="submit" className="submit-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form8;
